import { RefObject } from 'react';
import { GOOGLE_RECAPTCHA_SITE_KEY } from '@reverbdotcom/env';

interface Props {
  action: string;
  googleRecaptchaTokenInput: RefObject<HTMLInputElement>;
  form: HTMLFormElement;
}

export function runGoogleRecaptchaScript({
  action,
  googleRecaptchaTokenInput,
  form,
}: Props) {
  (window as any).grecaptcha.enterprise.ready(function () {
    (window as any).grecaptcha.enterprise.execute(GOOGLE_RECAPTCHA_SITE_KEY, { action }).then(function (token: string) {
      if (googleRecaptchaTokenInput.current) {
        googleRecaptchaTokenInput.current.value = token;
      }
      form.submit();
    });
  });
}
